const OldSystemFrame = () => import('@/views/OldSystemFrame');

export default [
  {
    path: 'km',
    component: {
      render (c) { return c('router-view') }
    },
    children: [
      {
        path: 'overview',
        component: OldSystemFrame,
        props:{
          url: '/login/templates/content.php?id=285'
        }
      },
      {
        path: 'new-km',
        component: OldSystemFrame,
        props:{
          url: '/login/templates/content.php?id=405&func=addOwnMeasure'
        }
      },
    ]
  },
]
